const RoadmapHyfye = () => {
  return (
<section id="roadmap" className="bg_light_dark">
  <div className="container">
    <div className="row text-center">
      <div className="col-lg-8 col-md-12 offset-lg-2">
        <div className="title_default_light title_border text-center">
          <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.2s">Our Roadmap</h4>
          <p className="animation" data-animation="fadeInUp" data-animation-delay="0.3s">
            Hyfye is on a mission to build the world’s first true economy of appreciation.
            We start with the Hyfye (HYE) token launch, giving everyone a way to tip and reward instantly.
          </p>
          <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
            After that, we will roll out a powerful decentralized platform where creators, users, and service providers can
            tip, earn, sell, and buy directly — no banks, no middlemen.  
          </p>
          <p className="animation" data-animation="fadeInUp" data-animation-delay="0.5s">
            Our goal: Build a global, user-owned economy where every action has real value. From liking a post to tipping a street artist,
            Hyfye makes gratitude a true currency.
          </p>
          <p className="animation" data-animation="fadeInUp" data-animation-delay="0.6s">
            Join us early, become part of something revolutionary, and let's create a more rewarding world together!
          </p>
        </div>
      </div>
    </div>
  </div>

  <div className="container-fluid">
    <div className="row">
      <div className="col-md-12 pl-0 pr-0 col-lg-12 col-sm-12">
        <div className="roadmap owl-carousel small_space">

          {/* Token Presale */}
          <div className="owl-item item">
            <div className="roadmap_box rd_complete current">
              <div className="roadmap_inner">
                <div className="icon_roadmap">
                  <i className="fa fa-rocket animation" data-animation="fadeInDown" data-animation-delay="0.2s"></i>
                </div>
                <div className="roadmap_icon"></div>
                <h6 className="animation" data-animation="fadeInUp" data-animation-delay="0.3s">May 2025</h6>
                <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">Token Presale Launch</p>
              </div>
            </div>
          </div>

          {/* Partnerships */}
          <div className="owl-item item">
            <div className="roadmap_box rd_complete">
              <div className="roadmap_inner">
                <div className="icon_roadmap">
                  <i className="fa fa-handshake-o animation" data-animation="fadeInDown" data-animation-delay="0.4s"></i>
                </div>
                <div className="roadmap_icon"></div>
                <h6 className="animation" data-animation="fadeInUp" data-animation-delay="0.3s">July 2025</h6>
                <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">First Partnerships</p>
              </div>
            </div>
          </div>

          {/* Exchange Listing */}
          <div className="owl-item item">
            <div className="roadmap_box">
              <div className="roadmap_inner">
                <div className="icon_roadmap">
                  <i className="fa fa-exchange animation" data-animation="fadeInDown" data-animation-delay="0.6s"></i>
                </div>
                <div className="roadmap_icon"></div>
                <h6 className="animation" data-animation="fadeInUp" data-animation-delay="0.3s">September 2025</h6>
                <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">Token Listing (BNB/ETH Pairs)</p>
              </div>
            </div>
          </div>

          {/* Beta Platform Launch */}
          <div className="owl-item item">
            <div className="roadmap_box">
              <div className="roadmap_inner">
                <div className="icon_roadmap">
                  <i className="fa fa-mobile-phone animation" data-animation="fadeInDown" data-animation-delay="0.8s"></i>
                </div>
                <div className="roadmap_icon"></div>
                <h6 className="animation" data-animation="fadeInUp" data-animation-delay="0.3s">November 2025</h6>
                <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">Hyfye Platform Beta</p>
              </div>
            </div>
          </div>

          {/* Global Go Live */}
          <div className="owl-item item">
            <div className="roadmap_box">
              <div className="roadmap_inner">
                <div className="icon_roadmap">
                  <i className="fa fa-thumbs-up animation" data-animation="fadeInDown" data-animation-delay="1s"></i>
                </div>
                <div className="roadmap_icon"></div>
                <h6 className="animation" data-animation="fadeInUp" data-animation-delay="0.3s">January 2026</h6>
                <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">Global Platform Launch</p>
              </div>
            </div>
          </div>

          {/* Marketing Expansion */}
          <div className="owl-item item">
            <div className="roadmap_box">
              <div className="roadmap_inner">
                <div className="icon_roadmap">
                  <i className="fa fa-globe animation" data-animation="fadeInDown" data-animation-delay="1.2s"></i>
                </div>
                <div className="roadmap_icon"></div>
                <h6 className="animation" data-animation="fadeInUp" data-animation-delay="0.3s">March 2026</h6>
                <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">Global User Growth</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
)};

export default RoadmapHyfye;
